import React from 'react';
import { Stack, Skeleton } from '@mui/material';

export const GeneralTabFallback = () => {
  return (
    <Stack gap="1rem">
      <Stack direction="row" gap="1rem">
        <Skeleton sx={{ height: '90px', width: '100%' }} variant="rectangular" />
        <Skeleton sx={{ height: '90px', width: '100%' }} variant="rectangular" />
        <Skeleton sx={{ height: '90px', width: '100%' }} variant="rectangular" />
        <Skeleton sx={{ height: '90px', width: '100%' }} variant="rectangular" />
        <Skeleton sx={{ height: '90px', width: '100%' }} variant="rectangular" />
        <Skeleton sx={{ height: '90px', width: '100%' }} variant="rectangular" />
      </Stack>
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
    </Stack>
  );
};
